import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function BackToTop() {
    const [show, setShow] = useState(false);
    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > window.innerHeight * 1.4);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);
    if (!show) return null;
    return (
        <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            data-testid="back-to-top"
            data-cursor-label="ASCEND"
            aria-label="Back to top"
            className="fixed bottom-6 right-6 z-[90] w-10 h-10 glass flex items-center justify-center text-signal hover:text-void hover:bg-signal transition-colors duration-300 ease-os"
            style={{ transition: "all 0.4s var(--ease-os)" }}
        >
            <ArrowUp size={14} />
        </button>
    );
}
